import { ReactNode } from 'react';
import { Control, FieldValues, Path } from 'react-hook-form';

import { CountryDropdown } from '../ui/country-dropdown';
import {
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../ui/form';

interface CountrySelectProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label?: ReactNode;
  description?: ReactNode;
}

export const CountrySelect = <T extends FieldValues>({
  control,
  name,
  label = 'Country',
  description,
}: CountrySelectProps<T>) => {
  return (
    <FormField
      name={name}
      control={control}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <CountryDropdown
            placeholder="Select country"
            defaultValue={field.value}
            {...field}
            onChange={(country) => {
              field.onChange(country.alpha2);
            }}
          />
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
